import { render, staticRenderFns } from "./TopData.vue?vue&type=template&id=508cbf3c&scoped=true"
import script from "./TopData.vue?vue&type=script&lang=js"
export * from "./TopData.vue?vue&type=script&lang=js"
import style0 from "./TopData.vue?vue&type=style&index=0&id=508cbf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cbf3c",
  null
  
)

export default component.exports